import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { sidenavItems } from '@app/shared/models/auth.model';
import { AgentModel } from '@app/shared/models/auth.model';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@app/shared/services/auth.service';

@Component({
    selector: 'app-side-nav',
    animations: [
        trigger('sidenavWidth', [
            state('open', style({ width: '280px' })),
            state('closed', style({ width: '70px' })),
            state('mobile', style({ width: '300px' })),
            transition('open <=> closed', animate('0.25s ease-in-out')),
            transition('open <=> mobile', animate('0.25s ease-in-out')),
            transition('closed <=> mobile', animate('0.25s ease-in-out')),
        ]),
    ],
    templateUrl: './side-nav.component.html',
    standalone: false
})
export class SideNavComponent implements OnInit {
  @Input() isExpanded: boolean = true;
  @Input() navItems: sidenavItems[] = [];
  @Input() isMobile: boolean = false;
  @Input() agentInfo: AgentModel = {} as AgentModel;

  @Output() gotoNav: EventEmitter<sidenavItems> = new EventEmitter<sidenavItems>();
  @Output() closeNav = new EventEmitter<void>();

  constructor(
    private router: Router,
    public translate: TranslateService,
    private authService: AuthService
  ) {}
  ngOnInit() {
  }

  // Filter out shippingtool and admintool on mobile
  get filteredNavItems() {
    return this.isMobile 
      ? this.navItems.filter(item => 
          item.routerLink !== 'shippingtool'
        )
      : this.navItems;
  }

  public goto(navItem: sidenavItems) {
    this.gotoNav.emit(navItem);
  }

  public onToggleLanguage() {
    const language = this.translate.currentLang === 'en' ? 'fr' : 'en';
    this.translate.use(language);
    localStorage.setItem('ppuLanguagePreference', language);
  }

  public async onLogout() {
    await this.authService.logout();
  }

  public onClose() {
    this.closeNav.emit();
  }
}
